module.exports = __webpack_public_path__ + "img/2021_09_dande_heianjingu_fin_web.be7feea0.jpg";